module.exports = __webpack_public_path__ + "media/application/images/ui/close-button-57722d3a386b15231602e58652cd0f19.png";